import { Component, Input } from '@angular/core';

const TEST_USER_EMAIL_SUFFIX = '@portaltest.reflact.it';
const EMPLOYEE_EMAIL_SUFFIX = '@reflact.com';

/** Zeigt je nach E-Mail-Domain ein Badge: "Testuser" (@portaltest.reflact.it) oder "Reflact Mitarbeiter" (@reflact.com). */
@Component({
    selector: 'app-test-user-badge',
    standalone: true,
    template: `
      @if (isTestUser) {<span class="user-badge user-badge-test">{{ testLabel }}</span>}
      @if (isEmployee) {<span class="user-badge user-badge-employee">{{ employeeLabel }}</span>}
    `,
    styles: [`
    .user-badge {
      display: inline-block;
      margin-left: 0.5rem;
      padding: 0.15rem 0.5rem;
      border-radius: 999px;
      color: #fff;
      font-size: 0.7rem;
      font-weight: 700;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      vertical-align: middle;
      white-space: nowrap;
    }
    .user-badge-test { background: #8b5cf6; }
    .user-badge-employee { background: #004f9f; }
  `]
})
export class TestUserBadgeComponent {
    @Input() public email?: string | null;
    public readonly testLabel = $localize`:@@testUserBadge:Testuser`;
    public readonly employeeLabel = $localize`:@@reflactEmployeeBadge:Reflact Mitarbeiter`;

    private get normalizedEmail(): string {
        return this.email?.trim().toLowerCase() ?? '';
    }

    public get isTestUser(): boolean {
        return this.normalizedEmail.endsWith(TEST_USER_EMAIL_SUFFIX);
    }

    public get isEmployee(): boolean {
        return this.normalizedEmail.endsWith(EMPLOYEE_EMAIL_SUFFIX);
    }
}
